module.exports = __webpack_public_path__ + "img/Q4.ef6ddda0.png";